__webpack_require__.p = "https://product-results.qa.core-artifacts.com/static/";